import NotFooterLayout from "layouts/NotFooterLayout";
import ManageParcelCreate from "components/ManageParcel/ManageParcelCreate";

function CreateManageParcelPage() {
  return (
    <NotFooterLayout namePage="สร้างพัสดุ">
      <div className="layout-content">
        <ManageParcelCreate />
      </div>
    </NotFooterLayout>
  );
}

export default CreateManageParcelPage;
